var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / thumbs-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 13.0004L13 22.0004C12.2044 22.0004 11.4413 21.6843 10.8787 21.1217C10.3161 20.5591 10 19.796 10 19.0004V15.0004H4.34003C4.05012 15.0036 3.76297 14.9439 3.49846 14.8251C3.23395 14.7064 2.99842 14.5316 2.80817 14.3128C2.61793 14.0941 2.47753 13.8365 2.39669 13.5581C2.31586 13.2797 2.29652 12.987 2.34003 12.7004L3.72003 3.70036C3.79235 3.22346 4.0346 2.78875 4.40212 2.47636C4.76965 2.16396 5.2377 1.99491 5.72003 2.00036H17M17 13.0004V2.00036M17 13.0004H19.67C20.236 13.0104 20.7859 12.8122 21.2154 12.4435C21.645 12.0749 21.9242 11.5613 22 11.0004V4.00036C21.9242 3.43942 21.645 2.92586 21.2154 2.55718C20.7859 2.1885 20.236 1.99035 19.67 2.00036H17",
    stroke: "#C10606",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.9a8582f8eb087b20ff06944b5a02cfcf.svg";
export { ForwardRef as ReactComponent };